import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state to show fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error (you can send this to monitoring tools like Sentry)
    console.error("Global ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <h1 style={styles.title}>Something went wrong.</h1>
          <p style={styles.subtitle}>
            Please refresh the page or contact support.
          </p>
          <pre style={styles.details}>{this.state.error?.message}</pre>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    padding: 40,
    textAlign: "center",
    background: "#fefefe",
    color: "#333",
  },
  title: {
    fontSize: 24,
    color: "#d32f2f",
  },
  subtitle: {
    marginTop: 10,
    fontSize: 16,
  },
  details: {
    marginTop: 20,
    fontSize: 14,
    color: "#555",
  },
};

export default ErrorBoundary;
